import type { FaireProductEntity } from "../../entity_types/product";

export const p_jr48nsjrkb: FaireProductEntity = {
  token: "p_jr48nsjrkb",
  type: "product",
  name: "Tamalitoz Dulce de Leche Starter Pack - Mix x 3 flavors 12ct",
  brandToken: "b_3pi3q87y4r",
  brandName: "Sugarox Candy Studio LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/f3fd8272c736d7d900c800cc9d02be853e5e841446d9c77f706a97ff7fe9c2c4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/377e9bb59853789ede956f731a151affd84984ba21a3e982df62c2461af0e5c2.png",
    "https://cdn.faire.com/fastly/62ad975de773cda61abe163a16c5c822a75710498ea3054dc02db779ffd8f4c1.png",
    "https://cdn.faire.com/fastly/7cfc67d0d21f03d40f12ec9493e77623d9e8eccf391390b5d54d46bb246e6056.png",
    "https://cdn.faire.com/fastly/c897877d39f01350c0bde90ba27e0d0921d18effad2f351d7dc48875acb7aa7a.jpeg",
    "https://cdn.faire.com/fastly/f872387376706da14ba4c45dd4e8fa62b557e0b24215a3a46919d4d5bfb61451.jpeg",
    "https://cdn.faire.com/fastly/b7768c98de1e9f1809724706db591e5beb8587e1d0508623e44a7352ec9f5e47.jpeg",
  ],
  priceDollars: 3.81,
  description:
    "Tamalitoz Dulce de Leche Caramel - Discovery Starter Pack\n\nEmbark on a decadent flavor journey with our Tamalitoz Dulce de Leche Caramel Discovery Starter Pack! This curated collection features 4 pouches of each of our three irresistible Dulce de Leche varieties, giving you a perfect introduction to the creamy, handcrafted indulgence that everyone will crave.\n\nInside this pack, you'll discover:\n\nThe Milky Güey: Pure, classic Dulce de Leche perfection, smooth and sweet with no chili.\nSpicy Mama: Our rich Dulce de Leche infused with a bold and delightful chili kick.\nDiva Diablo: Dangerously addictive clusters of spicy Dulce de Leche caramel on crunchy, bite-sized pretzels – a symphony of sweet, salty, and spicy!\nPerfect for sampling, gifting, or ensuring you have a favorite for every mood!",
  tags: [],
  msrpDollars: 7.62,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:47.524Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
